import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./mitigation-query-key-factory";

/**
 * Returns a list of allocated controls for the given SCTM
 *
 * @param {string} sctmId - uuid of the SCTM
 */
export const getSctmAllocatedControls = ({ sctmId }: { sctmId: string }) => {
  return Brm.sctmApi.getSCTMAllocatedcontrol(sctmId);
};

interface IUseSctmAllocatedControls {
  sctmId: string;
  options?: QueryOption<typeof getSctmAllocatedControls>;
}

/**
 * React-query hook for getting all allocated controls
 *
 * @param {string} sctmId - uuid of sctm
 * @param {object} config - react-query configuration object
 * @returns react-query for getSctmAllocatedControls
 */
export const useSctmAllocatedControls = ({ sctmId, options }: IUseSctmAllocatedControls) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.sctmKeys.allocatedControls(sctmId),
    queryFn: () => getSctmAllocatedControls({ sctmId }),
  });
};
